// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let TanDate = require("../../reason/common/types/TanDate.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Ordering = require("@rescript/runtime/lib/js/Stdlib_Ordering.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPageNextShowing_showing_graphql = require("../../__generated__/PropertyPageNextShowing_showing_graphql.bs.js");

let convertFragment = PropertyPageNextShowing_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, PropertyPageNextShowing_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

let ShowingFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function dateTimeToUnzonedDate(dateTime) {
  return UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(dateTime));
}

function PropertyPage__NextShowing(props) {
  let timezone = props.timezone;
  let showings = RescriptRelay_Fragment.useFragment(PropertyPageNextShowing_showing_graphql.node, convertFragment, props.showings);
  let arr = showings.filter(showing => DateFns.isAfter(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(showing.startDate)), TanDate.now())).slice();
  let nextShowing = Stdlib_Option.getOr(Stdlib_Option.map((arr.sort((a, b) => Stdlib_Ordering.fromInt(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(a.startDate)).getTime() - UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(b.startDate)).getTime() | 0)), arr)[0], showing => DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), timezone), "MMM d 'at' h:mm a")), "None scheduled");
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: "Next showing",
        className: "text-zinc-500 uppercase font-medium"
      }),
      JsxRuntime.jsx("div", {
        children: nextShowing,
        className: "text-lg font-medium"
      })
    ],
    className: "space-y-2"
  });
}

let make = PropertyPage__NextShowing;

exports.ShowingFragment = ShowingFragment;
exports.dateTimeToUnzonedDate = dateTimeToUnzonedDate;
exports.make = make;
/* Scalars Not a pure module */
